<div class="p-8">
  <!-- Header -->
  <div class="flex items-start justify-between mb-8">
    <div>
      <h1 class="text-sm font-bold text-navy-600">Configured Data Elements</h1>
      <p class="text-xs text-slate-500 mt-1">
        Create custom data fields and manage their assignment to specific programs.
      </p>
    </div>
    <button
      type="button"
      (click)="showCreate.set(true)"
      class="flex items-center gap-2 bg-accent-500 hover:opacity-90 text-white text-xs font-semibold px-4 py-2.5 rounded-xl transition-opacity cursor-pointer shrink-0"
    >
      <img src="/icons/plus-white-icon.svg" class="w-4 h-4" alt="" />
      Create Element
    </button>
  </div>

  <!-- Search -->
  <div class="flex items-center gap-3 mb-6">
    <div class="relative flex-1 max-w-xs">
      <img
        src="/icons/search-icon.svg"
        class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 pointer-events-none"
        alt=""
      />
      <input
        type="text"
        placeholder="Filter by Name"
        [value]="searchQuery()"
        (input)="onSearchInput($event)"
        class="w-full pl-9 pr-4"
      />
    </div>
  </div>

  <!-- Table -->
  <div class="bg-white rounded-2xl border border-slate-100 shadow-card overflow-hidden">
    <app-data-table
      [columns]="columns()"
      [rows]="dataElements()"
      [total]="total()"
      [page]="pageIndex() + 1"
      [pageSize]="pageSize"
      [loading]="loading()"
      [clickableRows]="true"
      (pageChange)="onPageChange($event)"
      (rowAction)="onRowAction($event)"
    />
  </div>
</div>

@if (showCreate()) {
  <app-create-data-element-modal
    (closed)="showCreate.set(false)"
    (saved)="showCreate.set(false); load()"
  />
}

@if (editingElement()) {
  <app-edit-data-element-modal
    [element]="editingElement()!"
    (closed)="editingElement.set(null)"
    (saved)="editingElement.set(null); load()"
    (removed)="editingElement.set(null); load()"
  />
}

<ng-template #dataTypeTpl let-row>
  <span
    class="inline-block px-2.5 py-0.5 rounded text-2xs font-semibold uppercase tracking-wide border border-slate-300 text-slate-500"
  >
    {{ row.dataType }}
  </span>
</ng-template>
